import React from 'react';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PopularCollectionItem, PopularCollectionHeader, PopularCollectionImage, PopularCollectionLikes, PopularCollectionLikeCount, PopularCollectionImages, CollectionImageColumn, CollectionImageWrapper, CollectionImageRow } from './styled';
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import { useHistory } from 'react-router-dom';
import IFeaturedCollection from '../../models/IFeaturedCollection';
import useCollectionLike from '../../data/useCollectionLike';
import cx from '../../../../utils/cx';

interface INFTPopularCollectionProps {
    data: IFeaturedCollection;
}

const NFTPopularCollection = (props: INFTPopularCollectionProps) => {
    const navigator = useHistory();
    const { action, isLiked, likeCount, actionTitle } = useCollectionLike(props.data.contractAddress.toLowerCase());

    const onClickImage = React.useCallback((tokenID: number) => (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.push(`/nft-detail/${props.data.contractAddress.toLowerCase()}/${tokenID}`);
    }, []);

    const onClickCollection = React.useCallback(() => {
        navigator.push(`/collection/${props.data.contractAddress.toLowerCase()}`);
    }, []);

    return (
        <PopularCollectionItem onClick={onClickCollection}>
            <PopularCollectionHeader>
                <PopularCollectionImage><img src={props.data.collectionImage} /><VerifiedIcon /></PopularCollectionImage>
                <span title={props.data.name}>{props.data.name}</span>
                <PopularCollectionLikes>
                    <PopularCollectionLikeCount className={cx({ liked: isLiked })} title={actionTitle} onClick={action}>
                        <FontAwesomeIcon icon={faHeart} size={"1x"} />
                        {likeCount > 0 && <div>{likeCount}</div>}
                    </PopularCollectionLikeCount>
                </PopularCollectionLikes>
            </PopularCollectionHeader>
            <PopularCollectionImages>
                <CollectionImageColumn>
                    <CollectionImageWrapper onClick={onClickImage(props.data.nfts[0].tokenID)}><img src={props.data.nfts[0].tokenImage} /></CollectionImageWrapper>
                </CollectionImageColumn>
                <CollectionImageColumn>
                    <CollectionImageRow>
                        <CollectionImageColumn>
                            <CollectionImageWrapper onClick={onClickImage(props.data.nfts[1].tokenID)}><img src={props.data.nfts[1].tokenImage} /></CollectionImageWrapper>
                        </CollectionImageColumn>
                        <CollectionImageColumn>
                            <CollectionImageWrapper onClick={onClickImage(props.data.nfts[2].tokenID)}><img src={props.data.nfts[2].tokenImage} /></CollectionImageWrapper>
                        </CollectionImageColumn>
                    </CollectionImageRow>
                    <CollectionImageRow style={{ flex: 2 }}>
                        <CollectionImageWrapper onClick={onClickImage(props.data.nfts[3].tokenID)}><img src={props.data.nfts[3].tokenImage} /></CollectionImageWrapper>
                    </CollectionImageRow>
                </CollectionImageColumn>
            </PopularCollectionImages>
        </PopularCollectionItem>
    )
}
export default NFTPopularCollection;